import React from 'react';
import TabPaper from '../Common/TabPaper';
import CriteriaList from './ExperienceTab/CriteriaList/CriteriaList';
import ExperienceScore from './ExperienceTab/ExperienceScore';

const ExperienceTab = () => {
    return (
        <div className="mb-5 flex flex-col gap-5">
            <TabPaper>
                <ExperienceScore />
            </TabPaper>
            <div className="border-border bg-card rounded-xl border">
                <CriteriaList />
            </div>
        </div>
    );
};

export default ExperienceTab;
